import { useEffect, useState } from 'react';

const COARSE_POINTER = '(pointer: coarse)';

function matchesCoarsePointer(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(COARSE_POINTER).matches
    : false;
}

/**
 * True on a device with a finger as its pointer (a phone, a tablet). The copy then says "pick" or
 * "tap", not "drop": a phone has no drag and drop (QA 2026-10-28, mob-19).
 */
export function useIsTouchDevice(): boolean {
  const [isTouch, setTouch] = useState(matchesCoarsePointer);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const query = window.matchMedia(COARSE_POINTER);
    const update = () => setTouch(query.matches);
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);
  return isTouch;
}
